import '@stimulus/polyfills'
import { Application, Controller } from 'stimulus'

const app = Application.start()

app.register('refosumu-company-show-inquiry-cta', class extends Controller {
  static targets = ['checkbox', 'pcLink', 'spLink']
  static values = {
    pcBaseUrl: String,
    spBaseUrl: String
  }

  connect() {
    this.updateSelection()
  }

  updateSelection() {
    const selectedReasons = this.checkboxTargets
      .filter(checkbox => checkbox.checked)
      .map(checkbox => checkbox.value)

    const nuriSelect = selectedReasons.join('-')

    this.updateLinks(nuriSelect)
  }

  updateLinks(nuriSelect) {
    // PC用
    if (this.hasPcLinkTarget && this.pcBaseUrlValue) {
      const pcUrl = this.buildUrl(this.pcBaseUrlValue, nuriSelect)
      this.pcLinkTarget.href = pcUrl
    }

    // SP用
    if (this.hasSpLinkTarget && this.spBaseUrlValue) {
      const spUrl = this.buildUrl(this.spBaseUrlValue, nuriSelect)
      this.spLinkTarget.href = spUrl
    }
  }

  buildUrl(baseUrl, nuriSelect) {
    if (!nuriSelect) {
      return baseUrl
    }

    const separator = baseUrl.includes('?') ? '&' : '?'
    return `${baseUrl}${separator}nuri_select=${encodeURIComponent(nuriSelect)}`
  }
})
